<template>
    <div class="facility-wrapper">
        <img :src="imageUrl" class='image'/>
        <div style="text-align: left; margin: 0 5%">
            <p v-html="description"></p>
        </div>
        <el-button :class=" enable ? 'btn' : 'btn disable-btn'" :disabled="!enable"
                   @click="$emit('click', {code: facilityCode,imageUrl: imageUrl})"
                   v-html="enable ? '開催時間と<br>ご予約はコチラ' : 'Coming soon'"/>
    </div>
</template>

<script>
    export default {
        name: "SelectFacility",
        props: {
            imageUrl: {
                type: String,
                default: ""
            },
            enable: {
                type: Boolean
            },
            description: {
                type: String,
                default: "沖縄県豊見城市豊崎「ちゅらウォーターパーク」<br>" +
                    "海のアクティビティの事前予約はこちらから。<br>" +
                    "<br>" +
                    "大人(15歳以上)：1,500円<br>" +
                    "子供(14歳以下)：1,000円<br>" +
                    "幼児(5歳以下)：500円<br>"
            },
            facilityCode: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (min-width: 1000px) {
        .facility-wrapper {
            width: 40%;
        }
        .image {
            width: 25vw !important;
        }
    }

    @media screen and (max-width: 1000px) {
        .facility-wrapper {
            width: 90%;
            font-size: 14px;

            &:not(:last-child) {
                margin-bottom: 30px;
            }
        }
    }

    .image {
        margin: 20px 10%;
        width: 60vw;
    }

    .facility-wrapper {
        border-radius: 4vw;
        border: 1px solid #3c78d8;
        box-sizing: border-box;
        margin: 0 5%;
        display: inline-block;
        padding: 10px;
        float: left;
        position: relative;
        text-align: center;
    }

    .warning {
        color: red;
    }

    .btn {
        width: 50%;
        margin: 0 25%;
        background-color: #da8135;
        color: white;
        font-size: 20px;
        font-weight: bold;
        line-height: 23px;
        border-radius: 15px;
        height: 74px;

        &:hover {
            background-color: #e89145;
            color: white;
        }
    }

    .disable-btn {
        background-color: #9fa4ad !important;
        color: white;
    }

    @media only screen and (max-width: 450px) {
        .btn {
            width: 100%;
            margin: 0%;
        }
    }
</style>